export default __webpack_public_path__ + "media/pins/map-pin-gray@2x-38904018.png";